import React from 'react';
import styled from 'styled-components';

import { InfoIcon } from '@zimpel/common/components/Icon';

type Props = { header?: string; } & React.PropsWithChildren;

export const StyledBox = styled.div`
  margin-bottom: 20px;
  padding: 2.5em;
  background: var(--color-white);
  text-align: center;
  border-radius: var(--border-box-radius);
`;

const StyledHintBox = styled(StyledBox)`
  background: var(--color-primary-box-background);
  text-align: center;
`;

const Title = styled.h1`
  padding-bottom: 3px;
  margin-top: 11px;
  font-size: var(--font-size-large);
  color: inherit;
`;

const Content = styled.p`
  font-size: var(--font-size-large);
`;

const HintBox: React.FC<Props> = ({ header, children }) => (
  <StyledHintBox>
    <InfoIcon size="2x" />
    <Title>{header}</Title>
    <Content>{children}</Content>
  </StyledHintBox>
);

export default HintBox;
export type { Props };
